import React from "react";

const Jumotron = () => {
  return (
    <div className="jumbotron">
      <h1 className="display-3">Community</h1>
      <p class="lead">We &lt;3 people who code!</p>
      <hr class="my-4" />
      <p className="lead">A disscussion forum for enthusiastic developers.</p>
    </div>
  );
};

export default Jumotron;
